module.exports = __webpack_public_path__ + "static/13-f4d8a60831235361defd9b3ff4e5a34a.jpg";